import { AIResponseMessage } from './AIResponseMessage';
import { UserMessage } from './UserMessage';

interface ConversationMessageProps {
  messageRole: 'user' | 'assistant';
  content: string;
  thinking?: string;
  isGenerating?: boolean;
  onRestore?: () => void;
  showRestore?: boolean;
}

export function ConversationMessage({
  messageRole,
  content,
  thinking,
  isGenerating = false,
  onRestore,
  showRestore = false,
}: ConversationMessageProps) {
  const isUser = messageRole === 'user';

  return isUser ? (
    <UserMessage content={content} />
  ) : (
    <AIResponseMessage
      content={content}
      thinking={thinking}
      isGenerating={isGenerating}
      onRestore={onRestore}
      showRestore={showRestore}
    />
  );
}
